import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { apolloClient } from '../apollo';

const history = createHistory();
const historyMiddleware = routerMiddleware(history);

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reduxStore = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(historyMiddleware, apolloClient.middleware(), thunk)
  )
);

export { reduxStore, history };

export default reduxStore;



// WEBPACK FOOTER //
// ./src/redux/store.js